import { render, staticRenderFns } from "./marketing-firstclassifi.vue?vue&type=template&id=48aad2e9&scoped=true&"
import script from "./marketing-firstclassifi.vue?vue&type=script&lang=js&"
export * from "./marketing-firstclassifi.vue?vue&type=script&lang=js&"
import style0 from "./marketing-firstclassifi.vue?vue&type=style&index=0&id=48aad2e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aad2e9",
  null
  
)

export default component.exports